module.exports = __webpack_public_path__ + "media/src/images/download-easy-guide-abc696144e8afc56a64bba327b67e4ec.jpg";